import "./style.css";

export const TwelveWeek = () => {
    return <div></div>;
};
